import styled from "styled-components";

export default c => styled(c)`
  .revenues-title {
    color: black !important;
  }

  .total-revenues {
    color: black !important;
    font-weight: bold;
  }
`;



// WEBPACK FOOTER //
// ./src/components/app/management/multilocality-sales-report/revenues/style.js